import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import AddDocumentContainer from './AddDocumentContainer'


const AddDocumentRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><AddDocumentContainer></AddDocumentContainer></Provider>
}

AddDocumentRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default AddDocumentRoot
